// Server-issued short-lived token fetcher for Deepgram WebSocket auth.
// Extracted from DeepgramStreamingEngine so the engine class stays under
// file-size hygiene after the Phase 1 reconnect path lands (which calls
// this twice — once at session start, once per reconnect attempt).

export async function fetchDeepgramToken(): Promise<string> {
  const r = await fetch("/api/asr/token", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  if (!r.ok) {
    throw new Error(`ASR token fetch failed: ${r.status}`);
  }
  const data = (await r.json()) as { token?: string; error?: string };
  if (!data.token) {
    throw new Error(data.error ?? "No token returned from /api/asr/token");
  }
  return data.token;
}
